// shared typing for the whole system

export enum PassioService {
    paraplan = "paraplan",
    navigator = "navigator",
}

export enum TimeTypes {
    pickedUp = "Picked Up",
    droppedOff = "Dropped Off",
}

export enum AssignmentTargets {
    driver = "Driver",
    vehicle = "Vehicle",
    route = "Route",
    run = "Run",
}

export interface BaseRequest {
    service: PassioService;
}

// extensible response types
export interface ResponseStatus {
    errorMessage: string;
    success: boolean;
    tokenExists: boolean;
    tokenIsValid: boolean;
}

export interface ListResponse<T> extends ResponseStatus {
    list: Array<T>;
}

export interface EntityResponse<T> extends ResponseStatus {
    entity: T;
}

export enum TripScheduleStatus {
    Unscheduled = 1,
    Scheduled = 2,
    Cancelled = 3,
    Noshowed = 4,
    Autoscheduled = 5,
    PickUpArrived = 6,
    PickUpPerformed = 7,
    DropOffArrived = 8,
    DropOffPerformed = 9,
    TripSigned = 10,
    Undo = 11,
    Downloaded = 12,
    BuiltFromPrevious = 13,
    NotifiedViaVoice = 14,
    NotifiedViaSMS = 15,
    NotifiedViaEmail = 16,
    NotifiedViaPush = 17,
    ScheduledFromPrevious = 18,
    ScheduledFromAutoRoute = 19,
    ScheduledManually = 20,
    TripChanged = 21,
    ScheduledRightClickAuto = 22,
    NotifiedOfCancelViaVoice = 23,
    SentTripDetailsViaEmail = 24,
    AcceptedTripRequest = 25,
    CASH_WaitingOnDispatcher = 26,
    CASH_WaitingOnDriver = 27,
    CASH_WaitingOnAutoSchedu = 28,
    CASH_NotifiedDispatcher = 29,
    CASH_AutoScheduleFailed = 30,
    CASH_AutoScheduleSucceed = 31,
    WaitingForApproval = 32,
    NotApproved = 33,
    Unknown = 34,
}

export enum TripCancelReason {
    cancelledByManager = "Cancelled by Mobility Manager",
    cancelledByRider = "Cancelled by Rider",
}

export enum AutoScheduleFailAction {
    NoAction = 0,
    EmailDispatcher = 1,
    CancelTripAndLetRiderKnow = 2,
}
